import HeroScrollIcon from "./hero-scroll.svg";

export const HeroScrollBlock = () => {
  return <HeroScrollIcon />;
};
